import React, { useCallback, useEffect,  useState } from 'react'
import { Row, Col, Button, Table} from "reactstrap";
import {  DataActividadSave, DetalleActividadPlanHEDTO, DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacionHE, ParamsHorasMesPlanificacionHEDTO, RegimenLaboralHEDTO, ServidorSeleccionado } from './TypesPlanificacionHE';

import {  EditarPlanificacionbyActividad, EliminarPlanificacionbyActividad, GuardarPlanificacionbyActividad } from './FunctionsPlanificacionHE';
import ExitoSVG from "./../../../../assets/icons/HorasExtras/Exitosa.svg"
import ErrorSVG from "./../../../../assets/icons/HorasExtras/Error.svg"
import  SaveSVG  from "./../../../../assets/icons/HorasExtras/Guardar.svg"
import  DeleteSVG  from "./../../../../assets/icons/HorasExtras/Msg ELIMINAR.svg"

import { ReactComponent as AgregarSVG } from "./../../../../assets/icons/HorasExtras/Agregar ACt.svg";
import { ReactComponent as EditarSVG } from "./../../../../assets/icons/HorasExtras/editar.svg";
import { ReactComponent as PdfSVG } from "./../../../../assets/icons/HorasExtras/PDF.svg";

import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"

import Swal from 'sweetalert2'
import ModalAsignarServidoresPlanHE from 'components/Varios/Modals/ModalAsignarServidoresPlanHE';
import ModalConfirmacionNew from 'components/Varios/Modals/ModalConfirmacionNew';
import TableDetalleActividadHE from './TableDetalleActividadHE';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import { boolean } from 'yargs';



type PropsActividadPlanificacionHE = {
    regimenLaborales: RegimenLaboralHEDTO[];
    regimenLaboralesPlan:DetalleRegimenLaboralHEDTO[];
    listadoServidores: DetalleServidoresPlanificacionHE[];
    recargarInformacion: () => Promise<void>
    actividadSeleccionadaEditar?: DetalleActividadPlanHEDTO;
    paramsHorasMesPlanificacionHE: ParamsHorasMesPlanificacionHEDTO[];
    detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[];
    idPlanificacionUnidad: number;
    docPlanificacionUnidad: string;
    idSolicitudReverso: number;
    estadoPlanificacion: string;
    mensajeNovedad: string;
    gruposActividad: DetalleGrupoActividadHEDTO[];
    idEstructura: number,
    puedeRealizarAccion?: boolean
    guardarParcial: () => void
    firmaryEnviar: () => Promise<void>
    solicitarReverso: () => void
    descargarResumenExcel: () => Promise<void>
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;
    mostrarReporteResumenProyPlanifExcel?: boolean | undefined;
    loadingAccionReporteExcel: boolean
}

type ModalConfirmacionActividad = {
    showModal: boolean,
    solicitud: DataActividadSave,
    content: HTMLElement | undefined
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}



export default function ActividadPlanificacionHE(props: PropsActividadPlanificacionHE) {
    const { 
        gruposActividad,
        regimenLaborales, 
        listadoServidores, 
        recargarInformacion, 
        actividadSeleccionadaEditar, 
        paramsHorasMesPlanificacionHE, 
        detalleActividadPlanHEDTOs, 
        idPlanificacionUnidad, 
        docPlanificacionUnidad, 
        idSolicitudReverso,
        estadoPlanificacion,
        mensajeNovedad,
        idEstructura,
        regimenLaboralesPlan, 
        puedeRealizarAccion,
        guardarParcial,
        firmaryEnviar,
        solicitarReverso,
        descargarResumenExcel,
        mostrarGuardarParcial,
        mostrarFirmaryEnviar,
        mostrarSolicitarReverso,
        mostrarReporteResumenProyPlanifExcel } = props;

    const defaultDataActividadSave: DataActividadSave = {
        regimenLaboralSeleccionado: 0,
        actividadSeleccionada: 0,
        horasSuplementarias: 0,
        horasExtraordinarias: 0,
        observacion: '',
        servidoresSeleccionados: []
    };

    const defaultStateModalConfirmacionAct = {
        showModal: false,
        solicitud: defaultDataActividadSave,
        content: undefined
    }

    const defaultSelectedServidor: ServidorSeleccionado = {
        idpersona: 0,
        identificacion: "",
        nombrecompleto: "",
        cargo: "",
        siglasregimen: "",
        rmu: 0,
        idregimen: 0,
        horasExtraordinarias: 0,
        horasSuplementarias: 0
    };

    const defaultParametrosPlanificacion: ParamsHorasMesPlanificacionHEDTO = {
        idheparamhorasmes: 0,
        idregimenlaboral: 0,
        horasExtraordinarias: 0,
        horasSuplementarias: 0,
        horasExtraySuple: 0
    };

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const [regimenLaboralSeleccionado, setRegimenLaboralSeleccionado] = useState(actividadSeleccionadaEditar?.idregimenLaboral || 0);
    const [actividadSeleccionada, setActividadSeleccionada] = useState(actividadSeleccionadaEditar?.idactividad || 0);
    
    const [horasSuplementarias, setHorasSuplementarias] = useState<number | undefined>(actividadSeleccionadaEditar?.horasSuplementarias);
    const [horasExtraordinarias, setHorasExtraordinarias] = useState<number | undefined>(actividadSeleccionadaEditar?.horasExtraordinarias);
    const [parametrosPlanificacion, setParametrosPlanificacion] = useState<ParamsHorasMesPlanificacionHEDTO>(defaultParametrosPlanificacion);
    const [observacion, setObservacion] = useState(actividadSeleccionadaEditar?.observacion || '');
    const [data, setData] = useState<DataActividadSave | undefined>(undefined)
    const [selectedServidores, setSelectedServidores] = useState<{ [key: number]: ServidorSeleccionado }>(
        actividadSeleccionadaEditar?.servidoresPlanificados.reduce((acc, servidor) => {
            acc[servidor.key] = servidor.value;
            return acc;
        }, {} as { [key: number]: ServidorSeleccionado }) || {}
    );

    const [updatedDetalleActividades, setUpdatedDetalleActividades] = useState<DetalleActividadPlanHEDTO[]>(detalleActividadPlanHEDTOs);

    const [modalConfirmacionActividad, setModalConfirmacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);
    const [modalEdicionActividad, setModalEdicionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);
    const [modalEliminacionActividad, setModalEliminacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);
    const [modalOpen, setModalOpen] = useState(false);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [isCrear, setIsCrear] = useState(false);


    let actividadesPlanificadas: number[] = [];

    if (props.detalleActividadPlanHEDTOs) {
        actividadesPlanificadas = props.detalleActividadPlanHEDTOs.map((v) => { return (v.idactividad) })
    }

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error", 
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    useEffect(() => {
        const parametros = paramsHorasMesPlanificacionHE.find(param => param.idregimenlaboral === regimenLaboralSeleccionado);
        if (parametros) {
            setParametrosPlanificacion(parametros);
        } else {
            setParametrosPlanificacion(defaultParametrosPlanificacion);
        }
    }, [regimenLaboralSeleccionado, paramsHorasMesPlanificacionHE]);


    useEffect(() => {
        setSelectedServidores(prevSelected => {
            const updatedSelected = { ...prevSelected };
            for (const key in updatedSelected) {
                if (updatedSelected.hasOwnProperty(key)) {
                    updatedSelected[key] = {
                        ...updatedSelected[key],
                        horasSuplementarias: horasSuplementarias !== undefined ? Number(horasSuplementarias) : undefined,
                        horasExtraordinarias: horasExtraordinarias !== undefined ? Number(horasExtraordinarias) : undefined
                    };
                }
            }
            return updatedSelected;
        });
    }, [horasSuplementarias, horasExtraordinarias]);

    function GetHTMLActividadesPlanificadas(solicitud: DataActividadSave, nombreActividad: string): React.ReactNode {     
        const sortedServidores = solicitud.servidoresSeleccionados.sort((a, b) => {
            const nombreA = a.value.nombrecompleto.toLowerCase();
            const nombreB = b.value.nombrecompleto.toLowerCase();
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        const htmlRowsSolicitudes = (
            <>
                <div className="modal-body">
                    <p><strong>Nombre actividad:</strong> {nombreActividad}</p>
                    <p><strong>Descripción específica de la actividad:</strong> {solicitud.observacion}</p>
                    <Table responsive bordered  className="table_planificacion_he">
                        <thead className="cabeceras_tabla_planificacion_he">
                            <tr>
                                <th>#</th>
                                <th>Cédula</th>
                                <th>Nombres</th>
                                <th>Cargo</th>
                                <th>Régimen</th>
                                <th>Horas Suplementarias</th>
                                <th>Horas Extraordinarias</th>
                            </tr>
                        </thead>
                        <tbody>
                        {sortedServidores.map((servidor,i) => (
                        <tr className='rows_tabla_planificacion_he' key={servidor.key}>
                            <td className="centrado">{i+1}</td>
                            <td>{servidor.value.identificacion}</td>
                            <td>{servidor.value.nombrecompleto}</td>
                            <td>{servidor.value.cargo}</td>
                            <td className='centrado'>{servidor.value.siglasregimen}</td>
                            <td className='centrado'>{servidor.value.horasSuplementarias}</td>
                            <td className='centrado'>{servidor.value.horasExtraordinarias}</td>
                        </tr>
                            
                        ))}
                        
                        </tbody>
                    </Table>
                </div>
            </>
        );
    
        return htmlRowsSolicitudes;
    }

    const isSelectedServidoresValid = Object.values(selectedServidores).some(servidor => servidor.idpersona);


    const handleSubmit = (dataActividadSave: DataActividadSave, nombreActividad: string) => {
        const content: any = GetHTMLActividadesPlanificadas(dataActividadSave, nombreActividad)
    
        if(isCrear){
            setModalConfirmacionActividad(
            { 
                showModal: true,
                solicitud: dataActividadSave,
                content
            })
        }else{
            setModalEdicionActividad(
            { 
                showModal: true,
                solicitud: dataActividadSave,
                content
            })
        }
        
    };

    const toggleModal = () => {
        setIsCrear(true)
        setModalOpen(!modalOpen);
    };

    const resetFormValues = () => {
        setRegimenLaboralSeleccionado(0);
        setActividadSeleccionada(0);
        setHorasSuplementarias(undefined);
        setHorasExtraordinarias(undefined);
        setObservacion('');
        setSelectedServidores({});
        setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
    };

    const handleGuardarPlanificacion = async (solicitud: DataActividadSave) => {
        const result = await GuardarPlanificacionbyActividad(solicitud);
        if (result.status === 200) {
            showAlert("La planificación de la actividad se ha guardado correctamente.", ExitoSVG, true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return 1;
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return -1;
        }
        
    };

    const handleEditarPlanificacion = async (solicitud: DataActividadSave) => {
        const result = await EditarPlanificacionbyActividad(solicitud);
        if (result.status === 200) {
            showAlert("La planificación de la actividad se ha editado correctamente.", ExitoSVG, true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return 1;
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return -1;
        }
        
    };
    

    useEffect(() => {
        if (actividadSeleccionadaEditar) {
            setRegimenLaboralSeleccionado(actividadSeleccionadaEditar.idregimenLaboral);
            setActividadSeleccionada(actividadSeleccionadaEditar.idactividad);
            setObservacion(actividadSeleccionadaEditar.observacion);

            const servidoresConHorasActualizadas = actividadSeleccionadaEditar.servidoresPlanificados.reduce((acc, servidor) => {
                acc[servidor.key] = servidor.value;
                return acc;
            }, {} as { [key: number]: ServidorSeleccionado });

            setSelectedServidores(servidoresConHorasActualizadas);

            const primerServidor = actividadSeleccionadaEditar.servidoresPlanificados[0]?.value;
            if (primerServidor) {
                setHorasSuplementarias(primerServidor.horasSuplementarias);
                setHorasExtraordinarias(primerServidor.horasExtraordinarias);
            }
        }
    }, [actividadSeleccionadaEditar]);

    const handleDelete = async (data: DataActividadSave, nombreActividad: string) => {
        const content: any = GetHTMLActividadesPlanificadas(data, nombreActividad )
        setModalEliminacionActividad(
        { 
            showModal: true,
            solicitud: data,
            content
        })
    };


    const handleDeleteActividad = async (idActividad: number) => {
        const result = await EliminarPlanificacionbyActividad(idActividad);
        if (result.status === 200) {
            showAlert("La planificación de la actividad se ha eliminado correctamente.", ExitoSVG, true);
            setUpdatedDetalleActividades(result.dataResponse);
            setModalEliminacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return 1;
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            setModalEliminacionActividad(defaultStateModalConfirmacionAct);
            await recargarInformacion()
            return -1;
        }
    };
    

    const handleEdit = (detalleActividad: DataActividadSave) => {
        setData(detalleActividad);
        setIsCrear(false);
        setModalOpen(true);
    };

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP]
    )


    return (
        <>
        <Row className="justify-content-between">
            {idPlanificacionUnidad === 0 ? (
                <Col className="d-flex" md="auto">
                    <Button className="btn-ingresar" title="Ingresar nueva actividad" onClick={toggleModal}>
                        <EditarSVG/> Ingresar nueva actividad
                    </Button>
                </Col>
            ): (
                <Col className="d-flex" md="auto">
                    
                </Col>
            )}


            <Col className="d-flex" md="auto">
                <Row className="justify-content-end">

                    {mostrarReporteResumenProyPlanifExcel && typeof (descargarResumenExcel) === "function" && (
                        <Col className="d-flex" md="auto">
                            <Button
                                disabled={props.loadingAccionReporteExcel}
                                onClick={descargarResumenExcel}
                                className="btn-Excel "
                            >
                                <div className="containerBotonImprimir">
                                    <div>Exportar a Excel</div>
                                    <IconoExcel className="iconBotonImprimir" />
                                </div>
                            </Button>
                        </Col>

                    )}
                    
                    {puedeRealizarAccion && (
                        <>
                            {mostrarGuardarParcial && (
                                <Col className="d-flex" md="auto">
                                    <Button className="btn-guardar" onClick={guardarParcial}>
                                        Guardar
                                    </Button>
                                </Col>
                            )}
                            {mostrarFirmaryEnviar && (
                                <Col className="d-flex" md="auto">
                                    <Button className="btn-firmar" onClick={firmaryEnviar}>
                                        Firmar y enviar a TH
                                    </Button>
                                </Col>
                            )}
                        </>
                    )}
                    
                    {mostrarSolicitarReverso && (
                        <Col className="d-flex" md="auto">
                            <Button className="btn-solicitar" onClick={solicitarReverso}>
                                Solicitar reverso
                            </Button>
                        </Col>
                    )}
                    { idPlanificacionUnidad !== 0 && (
                        <>
                            {estadoPlanificacion.trim() !== 'RE' && (
                                <Col className="d-flex" md="auto">
                                    <Button className="btn-ver-pdf" title="Ver PDF" onClick={() => onClickVerDoc(docPlanificacionUnidad)}>
                                        Ver PDF <PdfSVG/> 
                                    </Button>
                                </Col>
                            )}

                            {(estadoPlanificacion.trim() === 'RE' || estadoPlanificacion.trim() === 'MO')&& (
                                <Col className="d-flex" md="auto">
                                    <Button className="btn-ingresar" title="Ingresar nueva actividad" onClick={toggleModal}>
                                        <EditarSVG/> Ingresar nueva actividad
                                    </Button>
                                </Col>
                            )}
                        </>
                    )}

                    
                </Row>
            </Col>
        </Row>   
        
        

        {updatedDetalleActividades && updatedDetalleActividades.length > 0 && (
            <TableDetalleActividadHE 
                idEstructura = {idEstructura}
                mensajeNovedad = {mensajeNovedad}
                detalleActividadPlan={updatedDetalleActividades} 
                estadoPlanificacion = {estadoPlanificacion}
                onEdit={handleEdit} 
                onDelete={handleDelete}
                tipo='PL'
                puedeRealizarAccion={puedeRealizarAccion}
            />
        )}

        
        <ModalAsignarServidoresPlanHE
            isOpen={modalOpen}
            toggle={toggleModal}
            isCrear={isCrear}
            gruposActividad={gruposActividad}
            servidoresPlan={listadoServidores}
            regimenSeleccionado={regimenLaboralSeleccionado}
            selectedServidoresAnt = {selectedServidores}
            regimenLaborales={regimenLaborales}
            regimenLaboralesPlan={regimenLaboralesPlan}
            paramsHorasMesPlanificacionHE={paramsHorasMesPlanificacionHE}
            handleSubmit={handleSubmit}
            data={data}
            actividadesProyectadasPlanificadas={actividadesPlanificadas}
            tipo='PL'
            idEstructura={props.idEstructura}
        />

        <ModalConfirmacionNew
            show={modalConfirmacionActividad.showModal}
            size="lg"
            onClose={() => {
                setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
                resetFormValues();
            }}
            asyncAccion={true}
            asyncClose={true}
            closeAfterAccion={true}
            hideBotonCerrar={false}
            mensajeConfirmacion={"¿Está seguro/a que desea planificar esta actividad?"}
            nombreBotonAccion={"Aceptar"}
            nombreBotonCerrarModal={"Cancelar"}
            asyncOnClick={async () => await  handleGuardarPlanificacion(modalConfirmacionActividad.solicitud)}
            contentModal={modalConfirmacionActividad.content}
            tituloModal={"Guardar planificación de actividad"}
            botonesAccionParteSuperior={true}
            iconModal={SaveSVG}
            classNamemensajeConfirmacion={"mensaje-confirmacion"}
        />

        <ModalConfirmacionNew
            show={modalEdicionActividad.showModal}
            size="lg"
            onClose={() => {
                setModalEdicionActividad(defaultStateModalConfirmacionAct);
                resetFormValues();
            }}
            asyncAccion={true}
            asyncClose={true}
            closeAfterAccion={true}
            hideBotonCerrar={false}
            mensajeConfirmacion={"¿Está seguro/a que desea editar la planificación esta actividad?"}
            nombreBotonAccion={"Aceptar"}
            nombreBotonCerrarModal={"Cancelar"}
            asyncOnClick={async () => await  handleEditarPlanificacion(modalEdicionActividad.solicitud)}
            contentModal={modalEdicionActividad.content}
            tituloModal={"Editar planificación de actividad"}
            botonesAccionParteSuperior={true}
            iconModal={SaveSVG}
            classNamemensajeConfirmacion={"mensaje-confirmacion"}
        />

        <ModalConfirmacionNew
            show={modalEliminacionActividad.showModal}
            size="lg"
            onClose={() => {
                setModalEliminacionActividad(defaultStateModalConfirmacionAct);
                resetFormValues();
            }}
            asyncAccion={true}
            asyncClose={true}
            closeAfterAccion={true}
            hideBotonCerrar={false}
            mensajeConfirmacion={"¿Está seguro/a que desea eliminar la planificación esta actividad para todos los servidores listados a continuación?"}
            nombreBotonAccion={"Aceptar"}
            nombreBotonCerrarModal={"Cancelar"}
            asyncOnClick={async () => await  handleDeleteActividad(modalEliminacionActividad.solicitud.actividadSeleccionada)}
            //asyncOnClick={async () => await  ObtenerDiccionario()}
            contentModal={modalEliminacionActividad.content}
            tituloModal={"Eliminar planificación de actividad"}
            botonesAccionParteSuperior={true}
            iconModal={DeleteSVG}
            classNamemensajeConfirmacion={"mensaje-confirmacion"}
        />

        <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento planificación de la unidad'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}


        />
        </>


        
    )
}
